import React from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { userDispensariesAtom } from 'src/app/state/user-dispensaries';
import { formatDate } from 'src/app/utils/formatters';

import { Text, generalBannerStyles, SMALL_BANNER_HEIGHT } from './shared';

export function useLocationSuspensionBannerIsVisible() {
  const { selectedLocation } = useRecoilValue(userDispensariesAtom);
  const flags = useFlags();

  return !!selectedLocation?.StopDate && flags['pos.register.enable-stop-date-check.rollout'];
}

export function LocationSuspensionBanner() {
  const { selectedLocation } = useRecoilValue(userDispensariesAtom);
  const isVisible = useLocationSuspensionBannerIsVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <Banner>
      <Text>
        <span>
          Your Dutchie Account is currently past due and will be suspended on{' '}
          {formatDate(selectedLocation?.StopDate, false)}. To resolve email{' '}
          <Link href='mailto:suspensionreview@dutchie.com'>suspensionreview@dutchie.com</Link>
        </span>
      </Text>
    </Banner>
  );
}

const Link = styled.a`
  color: white;
  text-decoration: underline !important;
`;

const Banner = styled.div`
  background-color: #ff3e51;
  height: ${SMALL_BANNER_HEIGHT}px;
  border-bottom: 1px solid var(--color-grayscale-black);

  ${generalBannerStyles}
`;
